import GatewayModule from "./GatewayModule.js";
import EQError from "../../../utils/EQError";
import shajs from "sha.js";

import HuaweiE580KpiConverter from "./kpi/converter/HuaweiKpiConverter";

const DEFAULT_USERNAME = "admin";
const DEFAULT_PASSWORD = "admin";

const RESPONSE = "response";
const SES_INFO = "SesInfo";
const TOK_INFO = "TokInfo";
const TOKEN_KEY = "__RequestVerificationToken";
const TOKEN_ONE_KEY = "__RequestVerificationTokenone";
const TOKEN_TWO_KEY = "__RequestVerificationTokentwo";


const LOGOUT_ENDPOINT = "/api/user/logout";
const TOKEN_ENDPOINT = "/api/webserver/SesTokInfo";
const LOGIN_ENDPOINT = "/api/user/login";

const API_INFO_ENDPOINT = "/api/device/information"; // First call only
const API_STATUS_ENDPOINT = "/api/monitoring/status";
const API_WLAN_SETTINGS_ENDPOINT = "/api/wlan/basic-settings"; // First call only
const API_DEVICE_SIGNAL_ENDPOINT = "/api/device/signal";
const API_NET_PLMN_ENDPOINT = "/api/net/current-plmn";
const endpoints = ["/", LOGIN_ENDPOINT, API_INFO_ENDPOINT, API_STATUS_ENDPOINT, API_WLAN_SETTINGS_ENDPOINT, API_DEVICE_SIGNAL_ENDPOINT, API_NET_PLMN_ENDPOINT];
const sessionIDCookie = "SessionID";
const API_TIMEOUT = 3000;// in ms

// Properties
const API_RETRIEVAL_TIME = "retrievalTime";
import * as GatewayServiceConstants from "../GatewayService";


/*eslint-disable no-undef*/
export default class HuaweiE580 extends GatewayModule {

    /**
     * Constructor
     *
     * @param ip
     * @param username
     * @param password
     */
    constructor(ip, username = null, password = null) {
        super("Huawei", "E5180 / B525", HuaweiE580KpiConverter, null, null, ip, username, password);
        this.username = username ? username : DEFAULT_USERNAME;
        this.password = password ? password : DEFAULT_PASSWORD;
        this.sesInfo = null;
        this.tokInfo = null;
        this.authenticationToken = null;
        this.authenticationTokenOne = null;
        this.authenticationTokenTwo = null;
        this.apiCache = {};
    }

    SHA256andBase64(text) {
        return new Buffer(
            shajs("sha256").update(text).digest("hex"),
            'utf-8').toString('base64');
    }

    /**
     * Returns the URL to ping
     *
     * @returns {string} The ping URL
     */
    getPingUrl() {
        return "http://" + this.ip + TOKEN_ENDPOINT;
    }

    /**
     * Clean cookies environment
     */
    cleanCookies() {
        // Clean cookies
        if (window["chrome"]) {
            endpoints.forEach((endpoint) => {
                window["chrome"].cookies.remove({url: "http://" + this.ip + endpoint, name: "sid"});
                window["chrome"].cookies.remove({url: "http://" + this.ip + endpoint, name: sessionIDCookie});
            });

            window["chrome"].cookies.set({url: "http://" + this.ip, name: sessionIDCookie, value: this.sesInfo});
        }
    }

    /**
     * Set the request headers with authentication tokens
     *
     * @param req An XMLHttpRequest object
     */
    setRequestHeaders(req) {
        req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        req.setRequestHeader("Accept", "*/*");
        req.withCredentials = true;
        if (this.tokInfo && !this.authenticationToken) {
            req.setRequestHeader(TOKEN_KEY, this.tokInfo);
        }
        if (this.authenticationToken) {
            req.setRequestHeader(TOKEN_KEY, this.authenticationToken);
        }
        if (this.authenticationTokenOne) {
            req.setRequestHeader(TOKEN_ONE_KEY, this.authenticationTokenOne);
        }
        if (this.authenticationTokenTwo) {
            req.setRequestHeader(TOKEN_TWO_KEY, this.authenticationTokenTwo);
        }

    }

    /**
     * Authenticate action to the gateway (override if needed)
     *
     * @returns {Promise} A promise with the module as return, or en EQError
     */
    authenticate() {
        return new Promise((resolve, reject) => {
            // Clean
            this.sesInfo = null;
            this.tokInfo = null;
            this.authenticationToken = null;
            this.authenticationTokenOne = null;
            this.authenticationTokenTwo = null;
            const self = this;

            const oReqLogout = new XMLHttpRequest();
            oReqLogout.open("post", "http://" + self.ip + LOGOUT_ENDPOINT, true);
            oReqLogout.onreadystatechange = function() {
                if (this.readyState === XMLHttpRequest.DONE) {
                    // Login
                    const oReqAuthenticationFirstRequest = new XMLHttpRequest();

                    oReqAuthenticationFirstRequest.open("get", "http://" + self.ip + TOKEN_ENDPOINT, true);
                    oReqAuthenticationFirstRequest.onreadystatechange = function() {
                        if (this.readyState === XMLHttpRequest.DONE) {
                            if (this.status === 200) {
                                const parseString = require("xml2js").parseString;
                                // The option explicitChildren is used to avoid merging sub properties
                                // Take a tour on https://github.com/Leonidas-from-XIV/node-xml2js documentation
                                parseString(this.responseText, {explicitArray:false}, function (err, result) {
                                    if (!err && result) {
                                        if (result && result[RESPONSE] && result[RESPONSE][SES_INFO] && result[RESPONSE][TOK_INFO]) {
                                            const sesInfoArray = result[RESPONSE][SES_INFO].split("=");
                                            if (sesInfoArray.length === 1 || sesInfoArray.length === 2) {
                                                if (sesInfoArray.length === 2) {
                                                    self.sesInfo = sesInfoArray[1];//result[RESPONSE][SES_INFO];
                                                } else {
                                                    self.sesInfo = result[RESPONSE][SES_INFO];
                                                }

                                                self.tokInfo = result[RESPONSE][TOK_INFO];

                                                // Step 1 finished, starting step 2 ...
                                                const encodedPassword = self.SHA256andBase64(self.username + self.SHA256andBase64(self.password) + self.tokInfo);

                                                //const postDataForSecondRequest =

                                                const obj = {Username: self.username, password_type: 4, Password: encodedPassword};

                                                const Xml2jsBuilder = require("xml2js").Builder;
                                                const postDataForSecondRequestBuilder = new Xml2jsBuilder({
                                                    rootName:"request"
                                                });

                                                self.cleanCookies();

                                                // Let's do the second authentication request
                                                const oReqAuthenticationSecondRequest = new XMLHttpRequest();
                                                oReqAuthenticationSecondRequest.open("post", "http://" + self.ip + LOGIN_ENDPOINT, true);
                                                self.setRequestHeaders(oReqAuthenticationSecondRequest);
                                                oReqAuthenticationSecondRequest.onreadystatechange = function() {
                                                    if (this.readyState === XMLHttpRequest.DONE) {
                                                        if (this.status === 200) {
                                                            parseString(this.responseText, {explicitArray:false}, function (err, result) {
                                                                if (!err && result) {
                                                                    if (!result.error) {
                                                                        if (result && result.response && result.response && result.response === "OK"
                                                                            && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_KEY)
                                                                            && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_ONE_KEY)
                                                                            && oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_TWO_KEY)) {
                                                                            // Authentication succeed !

                                                                            if (window["chrome"]) {
                                                                                window["chrome"].cookies.getAll({
                                                                                    domain: self.ip,
                                                                                    path: "/",
                                                                                    name: sessionIDCookie
                                                                                }, function (cookies) {
                                                                                    if (cookies.length === 1) {
                                                                                        self.sesInfo = cookies[0].value;
                                                                                        self.authenticationToken = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_KEY);
                                                                                        self.authenticationTokenOne = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_ONE_KEY);
                                                                                        self.authenticationTokenTwo = oReqAuthenticationSecondRequest.getResponseHeader(TOKEN_TWO_KEY);
                                                                                        self.cleanCookies();
                                                                                        // Get some apis and set in cache for later

                                                                                        setTimeout(() => {
                                                                                            self.getApiInfo().then(() => {
                                                                                                resolve(self);
                                                                                            }).catch(() => {
                                                                                                resolve(self);
                                                                                            });
                                                                                        }, 500);

                                                                                    } else {
                                                                                        reject(new EQError("Authentication failed. No session id found.", 792812));
                                                                                    }
                                                                                });
                                                                            } else {
                                                                                reject(new EQError("No access to cookies.", 792813));
                                                                            }
                                                                        } else {
                                                                            reject(new EQError("Error - unexpected OK response while second authentication execution", 45219));
                                                                        }
                                                                    } else {
                                                                        // Error in authentication (XML parsing OK, bad response)
                                                                        /*
                                                                         <?xml version="1.0" encoding="UTF-8"?>
                                                                         <error>
                                                                         <code>125002</code>
                                                                         <message></message>
                                                                         </error>
                                                                         */
                                                                        if (result.error && result.error.code && parseInt(result.error.code) === GatewayServiceConstants.AUTH_FAILED_MAX_ATTEMPT_REACHED) {
                                                                            reject(new EQError("Max login attempt reached. Please try again in " + result.error.waittime + " minute" + (parseInt(result.error.waittime) > 1 ? "s" : ""), GatewayServiceConstants.AUTH_FAILED_MAX_ATTEMPT_REACHED));
                                                                        } else if (result.error && result.error.code && parseInt(result.error.code) === GatewayServiceConstants.AUTH_FAILED_INVALID_USERNAME_PASSWORD) {
                                                                            reject(new EQError("Invalid username or password (" + result.error.count + "/3)", GatewayServiceConstants.AUTH_FAILED_INVALID_USERNAME_PASSWORD));
                                                                        } else {
                                                                            reject(new EQError("Error (" + result.error.code[0] + ") while second authentication execution", 45218));
                                                                        }
                                                                    }
                                                                } else {
                                                                    reject(new EQError("Error (" + err.message + ") while second authentication request parsing XML : " + this.responseText, 45217));
                                                                }
                                                            });

                                                        } else {
                                                            reject(new EQError("Invalid response for second authentication request. Received code " + this.status + ".", 45216));
                                                        }
                                                    }
                                                };
                                                oReqAuthenticationSecondRequest.send(postDataForSecondRequestBuilder.buildObject(obj));
                                            } else {
                                                reject(new EQError("Invalid sesInfo length after split", 45215));
                                            }

                                        } else {
                                            reject(new EQError("Unexpected gateway result", 45214));
                                        }

                                    } else {
                                        reject(new EQError("Error (" + err.message + ") while first authentication request parsing XML : " + this.responseText, 45213));
                                    }
                                });
                            } else {
                                reject(new EQError("Invalid response for first authentication request. Received code " + this.status + ".", 45212));
                            }
                        }
                    };
                    oReqAuthenticationFirstRequest.send();
                }
            }

            oReqLogout.send('<?xml version: "1.0" encoding="UTF-8"?><request><Logout>1</Logout></request>');
        });
    }

    /**
     * Get an API
     * Note that authentication should be ran before
     *
     * @param endpoint An endpoint
     * @returns {Promise} A promise with an Object of API result as return, or an EQError
     */
    getAPI(endpoint) {
        const self = this;
        return new Promise((resolve, reject) => {
            let success = false;

            const oReq = new XMLHttpRequest();
            oReq.open("get", "http://" + self.ip + endpoint, true);
            self.setRequestHeaders(oReq);
            oReq.onreadystatechange = function() {
                if (this.readyState === XMLHttpRequest.DONE) {
                    if (this.status === 200) {
                        success = true;
                        const parseString = require("xml2js").parseString;
                        parseString(this.responseText, {explicitArray:false}, function (err, result) {
                            if (!err && result) {
                                if (!result.error && result.response) {
                                    resolve(result.response);
                                } else {
                                    reject(new EQError("Invalid response for API request " + endpoint + ". XML contains functional error : " + ((result.error && result.error.code && result.error.code.length > 0)? result.error.code[0] : "unknown") + ".", 45918));
                                }
                            } else {
                                reject(new EQError("Invalid response for API request " + endpoint + ". XML parsing error : " + err.message + ".", 45917));
                            }
                        });
                    } else {
                        reject(new EQError("Invalid response for API request " + endpoint + ". Received code " + this.status + ".", 45916));
                    }
                }
            };

            setTimeout(() => {
                if (!success) {
                    oReq.abort();
                }
            }, API_TIMEOUT);

            oReq.send();
        });
    }

    /**
     * Call all APIs available for the Huawei
     * Note that authentication should be ran before
     *
     * @returns {Promise} A promise with an Object with API results as return, or an EQError
     */
    getApiInfo() {
        return new Promise((resolve, reject) => {
            const self = this;
            //self.cleanCookies();

            const pStatus = self.getAPI(API_STATUS_ENDPOINT);
            const pSignal = self.getAPI(API_DEVICE_SIGNAL_ENDPOINT);
            const pPlmn = self.getAPI(API_NET_PLMN_ENDPOINT);
            const pInfo = self.getAPI(API_INFO_ENDPOINT);
            const pWlanSettings = self.getAPI(API_WLAN_SETTINGS_ENDPOINT);
            const apis = [
                pStatus,
                pSignal,
                pPlmn,
                pInfo,
                pWlanSettings
            ];

            const startTimestamp = Date.now();
            this.executeChainedPromises(apis, (results, errors) => {
                if (errors.length === apis.length) {
                    // Failed
                    reject(errors[0]);
                } else {
                    // Merge all results in a single object
                    let rawData = self.apiCache;
                    rawData[API_RETRIEVAL_TIME] = (Date.now() - startTimestamp);

                    results.forEach((result) => {
                        rawData = Object.assign(rawData, result);
                    });

                    // Clean values (set "" to null values)
                    Object.keys(rawData).forEach((rawDataKey) => {
                        if (rawData[rawDataKey] === "") {
                            rawData[rawDataKey] = null;
                        }
                    });

                    // Processing KPI : convert, validate ...
                    self.processKpi(rawData).then((rawKpi) => {
                        resolve(rawKpi);
                    }).catch((e) => {
                        reject(e);
                    });
                }
            });
        });
    }

    /**
     * Execute an array of promises sequencially
     *
     * @param promises
     * @param cb
     * @param stopOnFailed
     */
    executeChainedPromises(promises, cb, stopOnFailed = false) {
        const success = [];
        const failed = [];
        let hasFailed = false;
        promises.reduce((accumulatorPromise, nextPromise) => {
            return accumulatorPromise.then(() => {
                if (!hasFailed || !stopOnFailed) {
                    return nextPromise;
                } else {
                    return null;
                }
            }).then((r) => {
                if (!stopOnFailed || (stopOnFailed && !hasFailed)) {
                    success.push(r);
                    if ((success.length + failed.length) === promises.length && cb) {
                        cb(success, failed);
                    }
                }
            }).catch((e) => {
                hasFailed = true;
                failed.push(e);
                if (cb && !stopOnFailed && (success.length + failed.length) === promises.length || stopOnFailed) {
                    cb(success, failed);
                }
            });
        }, Promise.resolve());
    }
}


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/HuaweiGatewayModule.js